import React from 'react';
import { Grid, Button, makeStyles, colors } from '@material-ui/core';

import useSingleFormPage from './useSingleFormPage';

const useStyles = makeStyles({
  submitButton: {
    backgroundColor: colors.red[400],
    color: colors.grey[50],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
});

const SingleFormPage = ({
  inputValue,
  onInputChange,
  onInputSubmit,
  validator,
  Input,
  submitButtonLabel,
  renderHeader,
  renderFooter = renderDefaultFooter,
}) => {
  const { errorMessage, onChange, onSubmit } = useSingleFormPage({
    inputValue,
    onChange: onInputChange,
    onSubmit: onInputSubmit,
    validator,
  });

  return (
    <Grid container direction="column" spacing={4}>
      {renderHeader && <Grid item>{renderHeader(onChange)}</Grid>}

      <Grid item>
        <Input
          errorMessage={errorMessage}
          value={inputValue}
          onChange={onChange}
        ></Input>
      </Grid>

      <Grid item>
        {renderFooter(onSubmit, { submitButtonLabel, onChange })}
      </Grid>
    </Grid>
  );
};

const renderDefaultFooter = (onSubmit, extraParams) => {
  return (
    <DefaultFooter
      onSubmit={onSubmit}
      extraParams={extraParams}
    ></DefaultFooter>
  );
};

const DefaultFooter = ({ onSubmit, extraParams }) => {
  const { submitButtonLabel } = extraParams;
  const classes = useStyles();
  return (
    <Grid item container justify="flex-end">
      <Button onClick={onSubmit} className={classes.submitButton}>
        <b>{submitButtonLabel}</b>
      </Button>
    </Grid>
  );
};

export default SingleFormPage;
